import React, { useState } from "react";
import { makeStyles, TextField } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Pagination } from "react-bootstrap";

const useStyles = makeStyles((theme) => ({
	container: {
		display: "flex",
		flexWrap: "wrap",
	},
	textField: {
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
		width: 200,
	},
}));

export function BotStatus() {
	const classes = useStyles();
	// The first commit of Material-UI
	const [selectedDate, setSelectedDate] = React.useState(
		new Date("2014-08-18T21:11:54")
	);

	function handleDateChange(date) {
		setSelectedDate(date);
	}

	return (
		<div id="pageid29">
			<div className="top-row gutter-b d-flex justify-content-end align-items-center">
				<form className={classes.container} className="bg-white" noValidate>
					<TextField
						id="date"
						type="date"
						defaultValue="2021-05-24"
						className={classes.textField}
						InputLabelProps={{
							shrink: true,
						}}
					/>
				</form>
				<span> ~ </span>
				<form className={classes.container} className="bg-white" noValidate>
					<TextField
						id="date"
						type="date"
						defaultValue="2021-05-24"
						className={classes.textField}
						InputLabelProps={{
							shrink: true,
						}}
					/>
				</form>
			</div>
			<div className="gutter-b graph">{/* 그래프 영역 */}</div>
			<div className="gutter-b table">
				<div className="gutter-b d-flex align-items-center justify-content-between w-100">
					<b>총 40건</b>
					<Button className={`btn btn-light-dark font-weight-bold text-white`}>
						엑셀 다운로드
					</Button>
				</div>
				<div className="table-responsive">
					<table
						className="table table-head-custom table-vertical-center bg-white"
						id="kt_advance_table_widget_1"
					>
						<thead>
							<tr className="text-left">
								<th style={{ width: "150px" }}>Bot ID</th>
								<th style={{ width: "100px" }}>실행 결과</th>
								<th style={{ width: "300px" }}>실행 작업명</th>
								<th style={{ minWidth: "100px" }}>실행 타입</th>
								<th style={{ minWidth: "150px" }}>실행 시간</th>
								<th style={{ minWidth: "150px" }}>실행 일시</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Logan1</td>
								<td>
									<span className="label label-xl label-inline label-success">
										성공
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>시간지연 어쩌구 저쩌구 예약 어쩌구</nobr>
								</td>
								<td>레시피</td>
								<td>16:52:20 - 16:55:20</td>
								<td>2021-05-13 16:52:20</td>
							</tr>
							<tr>
								<td>Logan2</td>
								<td>
									<span className="label label-xl label-inline label-primary">
										실패
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>
										시간지연 어쩌구 저쩌구 예약 어쩌구 시간지연 어쩌구 저쩌구
										예약 어쩌구 시간지연 어쩌구 저쩌구 예약 어쩌구
									</nobr>
								</td>
								<td>북</td>
								<td>16:52:20 - 16:55:20</td>
								<td>2021-05-13 16:52:20</td>
							</tr>
							<tr>
								<td>Logan2</td>
								<td>
									<span className="label label-xl label-inline label-primary">
										실패
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>
										시간지연 어쩌구 저쩌구 예약 어쩌구 시간지연 어쩌구 저쩌구
										예약 어쩌구 시간지연 어쩌구 저쩌구 예약 어쩌구
									</nobr>
								</td>
								<td>북</td>
								<td>16:52:20 - 16:55:20</td>
								<td>2021-05-13 16:52:20</td>
							</tr>
							<tr>
								<td>Logan2</td>
								<td>
									<span className="label label-xl label-inline label-primary">
										실패
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>
										시간지연 어쩌구 저쩌구 예약 어쩌구 시간지연 어쩌구 저쩌구
										예약 어쩌구 시간지연 어쩌구 저쩌구 예약 어쩌구
									</nobr>
								</td>
								<td>북</td>
								<td>16:52:20 - 16:55:20</td>
								<td>2021-05-13 16:52:20</td>
							</tr>
							<tr>
								<td>Logan2</td>
								<td>
									<span className="label label-xl label-inline label-primary">
										실패
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>
										시간지연 어쩌구 저쩌구 예약 어쩌구 시간지연 어쩌구 저쩌구
										예약 어쩌구 시간지연 어쩌구 저쩌구 예약 어쩌구
									</nobr>
								</td>
								<td>북</td>
								<td>16:52:20 - 16:55:20</td>
								<td>2021-05-13 16:52:20</td>
							</tr>
							<tr>
								<td>Logan2</td>
								<td>
									<span className="label label-xl label-inline label-primary">
										실패
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>
										시간지연 어쩌구 저쩌구 예약 어쩌구 시간지연 어쩌구 저쩌구
										예약 어쩌구 시간지연 어쩌구 저쩌구 예약 어쩌구
									</nobr>
								</td>
								<td>북</td>
								<td>16:52:20 - 16:55:20</td>
								<td>2021-05-13 16:52:20</td>
							</tr>
							<tr>
								<td>Logan2</td>
								<td>
									<span className="label label-xl label-inline label-primary">
										실패
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>
										시간지연 어쩌구 저쩌구 예약 어쩌구 시간지연 어쩌구 저쩌구
										예약 어쩌구 시간지연 어쩌구 저쩌구 예약 어쩌구
									</nobr>
								</td>
								<td>북</td>
								<td>16:52:20 - 16:55:20</td>
								<td>2021-05-13 16:52:20</td>
							</tr>
							<tr>
								<td>Logan2</td>
								<td>
									<span className="label label-xl label-inline label-primary">
										실패
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>
										시간지연 어쩌구 저쩌구 예약 어쩌구 시간지연 어쩌구 저쩌구
										예약 어쩌구 시간지연 어쩌구 저쩌구 예약 어쩌구
									</nobr>
								</td>
								<td>북</td>
								<td>16:52:20 - 16:55:20</td>
								<td>2021-05-13 16:52:20</td>
							</tr>
							<tr>
								<td>Logan2</td>
								<td>
									<span className="label label-xl label-inline label-primary">
										실패
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>
										시간지연 어쩌구 저쩌구 예약 어쩌구 시간지연 어쩌구 저쩌구
										예약 어쩌구 시간지연 어쩌구 저쩌구 예약 어쩌구
									</nobr>
								</td>
								<td>북</td>
								<td>16:52:20 - 16:55:20</td>
								<td>2021-05-13 16:52:20</td>
							</tr>
							<tr>
								<td>Logan2</td>
								<td>
									<span className="label label-xl label-inline label-primary">
										실패
									</span>
								</td>
								<td className="text-overflow-ellipsis">
									<nobr>
										시간지연 어쩌구 저쩌구 예약 어쩌구 시간지연 어쩌구 저쩌구
										예약 어쩌구 시간지연 어쩌구 저쩌구 예약 어쩌구
									</nobr>
								</td>
								<td>북</td>
								<td>16:52:20 - 16:55:20</td>
								<td>2021-05-13 16:52:20</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div className="row">
				<div className="d-flex flex-center w-100">
					<Pagination>
						<Pagination.Prev />

						<Pagination.Item>{1}</Pagination.Item>
						<Pagination.Item>{2}</Pagination.Item>
						<Pagination.Item active>{3}</Pagination.Item>
						<Pagination.Item disabled>{4}</Pagination.Item>
						<Pagination.Item>{5}</Pagination.Item>

						<Pagination.Next />
					</Pagination>
				</div>
			</div>
		</div>
	);
}

export default BotStatus;
